"use client";

import React from "react";
import { SectionContentProps } from "../../types";
import EditableText from "../../core/EditableText";
import { PiArrowRight, PiSparkle } from "react-icons/pi";

export default function AIHero({ content, onContentChange, isSelected }: SectionContentProps) {
  const fontFamily = content.fontFamily || "'Inter', sans-serif";

  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <div
      className={`relative overflow-hidden py-32 bg-black text-white text-center ${isSelected ? "ring-2 ring-blue-500 relative z-20" : ""}`}
      style={{ fontFamily }}
    >
      {/* Background neon glow effects */}
      <div className="absolute top-1/4 left-1/3 w-[500px] h-[300px] bg-purple-600/10 rounded-full blur-[100px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/3 w-[500px] h-[300px] bg-indigo-600/10 rounded-full blur-[100px] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 space-y-8 relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-purple-950/20 border border-purple-900/30 text-xs font-bold text-purple-300">
          <PiSparkle className="w-4 h-4 text-purple-400" />
          <span>Next Gen Intelligence</span>
        </div>

        <h1 className="text-4xl sm:text-6xl font-extrabold tracking-tight text-white leading-tight">
          <EditableText
            value={content.title || "The Future of AI is Here"}
            onChange={(val) => updateContent("title", val)}
            as="span"
          />
        </h1>

        <p className="text-lg sm:text-xl text-slate-400 max-w-2xl mx-auto leading-relaxed">
          <EditableText
            value={content.subtitle || "We build next-generation language models and agentic automation workflows."}
            onChange={(val) => updateContent("subtitle", val)}
            as="span"
          />
        </p>

        <div className="flex flex-wrap justify-center gap-4 pt-4">
          <a
            href={content.primaryBtnLink || "#signup"}
            className="px-6 py-3 rounded-full bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-750 hover:to-indigo-750 text-white font-semibold text-sm shadow-lg shadow-purple-500/20 transition-all flex items-center gap-2"
          >
            {content.primaryCta || "Get Started"}
            <PiArrowRight className="w-4 h-4" />
          </a>
          <a
            href={content.secondaryBtnLink || "#demo"}
            className="px-6 py-3 rounded-full bg-slate-950 border border-purple-900/30 hover:bg-slate-900 text-white font-semibold text-sm transition-all"
          >
            {content.secondaryCta || "Documentation"}
          </a>
        </div>
      </div>
    </div>
  );
}
